import { useParams } from "react-router-dom";
import { ProjectDashboard } from "../../projects/components";

function Project() {
  let { projectId } = useParams() as any;
  
  return <ProjectDashboard projectId={projectId}></ProjectDashboard>
}

export default Project;